/* src/app/home/contact-modal/contact-modal.component.scss */
.modal-header {
  border-bottom: none;
}
.modal-footer {
  border-top: none;
}
p {
  line-height: 13px;
}
.cancel {
  padding: 10px;
  max-width: 900px;
  width: 100%;
}
.loading {
  min-height: 300px;
  max-width: 900px;
  width: 100%;
  padding: 0 16px;
}
.btn-green {
  color: white;
  background-color: #00857D;
  border-radius: 35px;
  width: 97px;
  height: 36px;
}
.modal-body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
@media (min-width: 740px) {
  .hours-of-operation {
    display: flex;
    gap: 20px;
  }
}
.hours-of-operation .label {
  font-weight: bold;
}
.hours-of-operation .hours {
  display: grid;
  grid-template-columns: minmax(105px, max-content) max-content;
  line-height: 1.3em;
}
@media (max-width: 739px) {
  .hours-of-operation .hours {
    padding-left: 20px;
    padding-top: 10px;
  }
}
/*# sourceMappingURL=contact-modal.component.css.map */
